// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { color, Table, TabTrigger } from '@kintent/glide';
import { UilLock as LockIcon } from '@iconscout/react-unicons';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 16px;
  row-gap: 32px;
`;

export const ListItem = styled.div`
  background-color: white;
  border-radius: 8px;

  border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 50)};

  box-shadow: ${({ theme }) => `${theme.boxShadow.drop} ${color(theme.colorV2.system.gray, 100)}`};

  cursor: pointer;

  padding: 12px;
`;

export const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  border-radius: 4px;
  // Service now color
  background-color: #62d84e;
`;

export const StyledLockIcon = styled(LockIcon)`
  // Color is not defined in the theme
  fill: #b0461a;
`;

export const StyledTabTrigger = styled(TabTrigger)`
  border-color: ${({ theme }) => color(theme.colorV2.system.border, 600)};
  padding: 0px 12px;

  span {
    font-weight: 500;
    font-family: Lato;
  }

  &[data-state='active'] {
    // Service now color
    background-color: #62d84e;
    border-color: ${({ theme }) => color(theme.colorV2.system.border, 600)};
    span {
      color: ${({ theme }) => color(theme.colorV2.system.gray, 950)};
    }
  }
  &[data-state='inactive'] {
    span {
      color: ${({ theme }) => color(theme.colorV2.system.gray, 800)};
    }
  }
  &:hover {
    border-color: ${({ theme }) => color(theme.colorV2.system.border, 950)};
  }
  &[data-state='active'] + [data-state='inactive'],
  &:hover + [data-state='inactive'],
  &:first-of-type {
    border-left-color: ${({ theme }) => color(theme.colorV2.system.border, 600)};
  }
`;

export const StyledTable = styled(Table)`
  tr td span {
    font-weight: 500;
    font-family: Lato;
  }
  tr {
    grid-template-columns: 1fr 2fr 0.5fr 48px;
  }
`;
